export const USERNAME = 'username';
export const ACCESS_TOKEN = 'accessToken';